import styled, { css } from 'styled-components';

import { wave } from './wave';

export interface AnimatedDotProps {
  delay?: number;
  fill: string;
  fillActive: string;
  d: string;
  duration?: number;
}

export const ANIMATION_DURATION = 1.2;

const AnimatedDot = styled.path.attrs<AnimatedDotProps>(props => ({
  'aria-hidden': true,
  delay: props.delay,
  d: props.d,
}))<AnimatedDotProps>`
  transform-origin: center;
  fill: ${({ fill }) => fill};
  stroke: none;
  ${({ fill, fillActive, duration = ANIMATION_DURATION }) => {
    const kf = wave({ fill, fillActive });
    return css`
      animation: ${kf} ${duration}s infinite linear;
    `;
  }}
  ${({ delay }) =>
    delay !== undefined &&
    css`
      animation-delay: ${delay}s;
    `}
`;

export default AnimatedDot;
